import { motion } from "framer-motion";
import { useState } from "react";

const FloatingInput = ({ label, type = "number", value: controlledValue, onChange, onKeyPress,maxlength,disabled=false }) => {
  const [focused, setFocused] = useState(false);
  const [internalValue, setInternalValue] = useState("");
  
  // Use controlled value if provided, otherwise use internal state
  const value = controlledValue !== undefined ? controlledValue : internalValue;
  const handleChange = (e) => {
    if (disabled) return; // 🔒 HARD STOP
  
    const newValue = e.target.value;
  
    if (type === "number" || type === "tel") {
      if (/^\d*$/.test(newValue)) {
        onChange ? onChange(e) : setInternalValue(newValue);
      }
    } else {
      onChange ? onChange(e) : setInternalValue(newValue);
    }
  };
  
  

  const isActive = focused || value !== "";

  return (
    <div className="relative w-full mb-5">
      {/* Floating Label */}
      <motion.label
        initial={false}
        animate={{
          y: isActive ? -12 : 12,
          x: 12,
          scale: isActive ? 0.85 : 1,
          color: isActive ? "#008C9E" : "#6b7280",
        }}
        transition={{ duration: 0.25 }}
        className="absolute left-3 top-0 pointer-events-none px-1
                   bg-white text-gray-500 font-medium"
      >
        {label}
      </motion.label>

      {/* Input Field */}
      <input
        type={type}
        value={value}
        onFocus={() => setFocused(true)}
        maxlength={maxlength}
        onBlur={() => setFocused(false)}
        onChange={handleChange}
        onKeyPress={onKeyPress}
        disabled={disabled}
        className={`w-full border border-gray-300 rounded-lg px-3 py-3 flex items-center gap-2
                   focus:outline-none focus:border-[#008C9E]
                   text-gray-700
                   ${disabled ? ' cursor-not-allowed ' : ''}`}
      />
    </div>
  );
};

export default FloatingInput;
